import React from 'react';
import ReactSyntaxHighlighter from 'react-syntax-highlighter/dist/cjs/default-highlight';
import dark from 'react-syntax-highlighter/dist/cjs/styles/hljs/a11y-dark';
import light from 'react-syntax-highlighter/dist/cjs/styles/hljs/a11y-light';
import type {AttributesObject} from '@packages/systems/wfdl';

export type CodeBlockSyntaxHighlighterProps = {
  code: string;
  elementProps: AttributesObject;
  language?: string;
  lineNumbers: boolean;
  theme: string;
};

const getTheme = (theme: string) => (theme === 'dark' ? dark : light);

const CodeBlockSyntaxHighlighter = React.memo(
  ({
    code,
    elementProps,
    language,
    lineNumbers,
    theme,
  }: CodeBlockSyntaxHighlighterProps) => {
    return (
      <ReactSyntaxHighlighter
        language={language}
        showLineNumbers={lineNumbers}
        wrapLongLines
        contentEditable={false}
        {...elementProps}
        style={getTheme(theme)}
      >
        {code}
      </ReactSyntaxHighlighter>
    );
  }
);

CodeBlockSyntaxHighlighter.displayName = 'CodeBlockSyntaxHighlighter';

export default CodeBlockSyntaxHighlighter;
